"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The KundenAdresse model module.
 * @module model/KundenAdresse
 * @version 1.0.44
 */
var KundenAdresse = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>KundenAdresse</code>.
   * Adresse eines Kunden
   * @alias module:model/KundenAdresse
   */
  function KundenAdresse() {
    _classCallCheck(this, KundenAdresse);
    KundenAdresse.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(KundenAdresse, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>KundenAdresse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/KundenAdresse} obj Optional instance to populate.
     * @return {module:model/KundenAdresse} The populated <code>KundenAdresse</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new KundenAdresse();
        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
        }
        if (data.hasOwnProperty('strasse')) {
          obj['strasse'] = _ApiClient.default.convertToType(data['strasse'], 'String');
        }
        if (data.hasOwnProperty('plz')) {
          obj['plz'] = _ApiClient.default.convertToType(data['plz'], 'String');
        }
        if (data.hasOwnProperty('ort')) {
          obj['ort'] = _ApiClient.default.convertToType(data['ort'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>KundenAdresse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>KundenAdresse</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['strasse'] && !(typeof data['strasse'] === 'string' || data['strasse'] instanceof String)) {
        throw new Error("Expected the field `strasse` to be a primitive type in the JSON string but got " + data['strasse']);
      }
      // ensure the json data is a string
      if (data['plz'] && !(typeof data['plz'] === 'string' || data['plz'] instanceof String)) {
        throw new Error("Expected the field `plz` to be a primitive type in the JSON string but got " + data['plz']);
      }
      // ensure the json data is a string
      if (data['ort'] && !(typeof data['ort'] === 'string' || data['ort'] instanceof String)) {
        throw new Error("Expected the field `ort` to be a primitive type in the JSON string but got " + data['ort']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} id
 */
KundenAdresse.prototype['id'] = undefined;

/**
 * @member {String} strasse
 */
KundenAdresse.prototype['strasse'] = undefined;

/**
 * @member {String} plz
 */
KundenAdresse.prototype['plz'] = undefined;

/**
 * @member {String} ort
 */
KundenAdresse.prototype['ort'] = undefined;
var _default = exports.default = KundenAdresse;